import React from "react"
import { ERROR_MESSAGE } from "../../../constants/common";
import { useQuestionsContext } from "../../../context/QuestionsContext";
import { useEventContext } from "../../../context/EventContext";
import { useModalContext } from "../../../context/ModalContext";
import SentSuccessfullyModal from "../../../components/QuestionMessages/SentSuccessfullyModal";
import WriteQuestionForm from "../../../components/QuestionMessages/WriteQuestionForm";
import UserBannedModal from "../../../components/User/UserBannedModal";

export default ({onClose, episode, member, selectStream, $locale}) => {
    const { event: { moduleQuestion } } = useEventContext();
    const { renderModal } = useModalContext();
    const { onWriteMessage } = useQuestionsContext();

    const onSentSuccessfully = () => {
        renderModal(
            SentSuccessfullyModal,
            { title: $locale.get('questions.sent.successfully') },
            null,
            true,
        );
    }

    const handleWriteMessage = async (data) => {
        try {
            await onWriteMessage(data);

            onClose();
            onSentSuccessfully();
        } catch (error) {
            console.error(error);

            if (error.data?.error?.message === ERROR_MESSAGE.CLIENT_IS_BANNED) {
                renderModal(
                    UserBannedModal,
                    { title: $locale.get('questions.sent.userBan') },
                    null,
                    true,
                );
            }
        }
    }

    return (
        <WriteQuestionForm
            maxMessageLength={moduleQuestion.maxMessageLength}
            onSubmit={handleWriteMessage}
            onClose={onClose}
            episode={episode}
            member={member}
            selectStream={selectStream}
        />
    );
}
